import { Typography } from 'antd';
import { LoginContainer, LoginCard, FullWidthSpace } from './styles';
import { ReactElement } from 'react';
import Content from './Content';

const { Title } = Typography;

const LoginPage = (): ReactElement => {
  return (
    <LoginContainer>
      <LoginCard>
        <FullWidthSpace direction='vertical' size='large'>
          <Title level={1}>ログイン</Title>
          <Content />
        </FullWidthSpace>
      </LoginCard>
    </LoginContainer>
  );
};

export default LoginPage;
